import { Component } from '@angular/core';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './pageNotFound.component.html',
    styleUrls: ['./pageNotFound.component.scss'],
    standalone: false
})
export class PageNotFoundComponent {
    public showErrorDetails: boolean = false;
    public showFallbackErrorText: boolean = false;
    public translateKey: string = 'GENERAL_PAGE_NOT_FOUND';
}
